import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';

/**
 * Slider component
 */
export default class HeroSlider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroSlider',
    refs: ['slider', 'prev', 'next', 'pagination'],
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Autoplay, Pagination, EffectFade],
      slidesPerView: 1,
      effect: 'fade',
      speed: 500,
      autoplay: { delay: 5000 },
      grabCursor: true,
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
      },
    });
  }
}
